<template>
  <b-modal size="lg"
           no-fade
           :visible="visible"
           :title="title"
           :ok-title="$t('button.save')"
           ok-variant="success"
           :cancel-title="$t('button.cancel')"
           @hide="onHide"
           @ok="onFormSubmit"
  >
    <form @submit.stop.prevent="onFormSubmit" >
      <div class="row">
        <div class="col-md-12">
          <b-alert :show="errorMessage!=null"
                   dismissible
                   variant="danger"
                   @dismissed="errorMessage=null">
            {{errorMessage}}
          </b-alert>
        </div>
      </div>
      <div class="row">
        <fg-input
          :label="$t('label.first_name')"
          name="first_name"
          required
          type="text"
          v-model="model.first_name"
          class="col-md-6 col-xs-12"
          v-validate="'required'"
          data-vv-as="first name"
          :error="errors.first('first_name')">
        </fg-input>
        <fg-input
          :label="$t('label.last_name')"
          name="last_name"
          type="text"
          v-model="model.last_name"
          class="col-md-6 col-xs-12"
          data-vv-as="last name"
          :error="errors.first('last_name')">
        </fg-input>

        <div class="form-group col-md-6 col-xs-12">
          <label>{{$t('label.country')}}</label>
          <el-select filterable default-first-option v-model="model.country" class="w-100">
            <el-option
              v-for="item in countries"
              :key="item.id"
              :label="item.name"
              :value="item.id">
              <span class="flag-icon" :class="'flag-icon-'+item.id.toLowerCase()"></span>
              <span class="ml-1">{{ item.name }}</span>
            </el-option>
            <span slot="prefix" class="el-input__prefix-inner" v-if="model.country">
                           <i class="el-input__icon flag-icon" :class="'flag-icon-'+model.country.toLowerCase()"></i>
                          </span>
          </el-select>
        </div>

        <div class="form-group col-md-6 col-xs-12">
          <label>{{$t('label.phone')}}<span class="required"> *</span></label>
          <el-input
            :placeholder="$t('label.phone')"
            name="phone"
            class="phone-input"
            autoComplete='off'
            v-model="model.localPhone">
            <span slot="prefix" class="el-input__icon" v-if="dialCode">{{dialCode}}</span>
          </el-input>
          <div class="text-danger invalid-feedback" style="display: block;" v-if="errors.first('phone')">
            {{errors.first('phone')}}
          </div>
        </div>


        <fg-input
          :label="$t('label.email')"
          name="email"
          type="text"
          v-model="model.email"
          class="col-sm-6"
          v-validate="'email'"
          :error="errors.first('email')">
        </fg-input>
      </div>
    </form>
  </b-modal>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { isPhoneNumberValid } from '@/utils'

  import { isValidNumber, getCountryCallingCode, parseNumber } from 'libphonenumber-js'
  import metadata from 'libphonenumber-js/metadata.full.json'

  export default {
    $_veeValidate: {
      validator: 'new',
    },
    props: {
      data: {
        type: Object,
        required: true,
      },
      show: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        loading: false,
        errorMessage: null,
        model: {
          id: null,
          first_name: null,
          last_name: null,
          email: null,
          phone: null,
          localPhone: '',
          country: null
        },
      };
    },
    computed: {
      ...mapGetters(['countries']),
      dialCode(){
        if(!this.model.country){
          return '';
        }
        const dialCode = getCountryCallingCode(this.model.country);
        if(dialCode){
          return `+${dialCode}`
        }
        return ''
      },
      title() {
        return this.model.id ? this.$i18n.t('label.update_contact') : this.$i18n.t('label.create_contact');
      },
      visible: {
        get() {
          return this.show;
        },
        set(value) {
          this.$emit('update:show', value);
        },
      },
    },
    watch:{
      'model.country': function(val){
        if(this.model.localPhone){
          this.validateInternationalPhone()
        }
      },
      'model.localPhone': function(val){
        if(val){
          this.validateInternationalPhone()
        }else{
          this.model.phone = '';
          this.errors.remove('phone');
        }

      }
    },
    methods: {
      validateInternationalPhone(){
        this.errors.remove('phone');
        const internationalPhone = `${this.dialCode}${this.model.localPhone}`;
        this.model.phone = internationalPhone;
        const validation = this.model.country?
          isValidNumber(internationalPhone, this.model.country, metadata):
          isValidNumber(internationalPhone, metadata);
        if(!validation){
          const error = {
            field: 'phone',
            msg: 'Invalid phone number',
            id: 'phone' // optional
          };
          this.errors.add(error)
        }else{
          this.errors.remove('phone')
        }
      },
      onHide(e){
        if(e.trigger!='ok'){
          this.$emit('update:show', false)
        }

      },
      onFormSubmit(e) {
        e.preventDefault();
        if (!this.errors.any()) {
          const data = {
            first_name: this.model.first_name,
            last_name: this.model.last_name,
            email: this.model.email,
            phone: this.model.phone,
            country: this.model.country
          };

          if(data.first_name && data.phone){
            if(!data.country){
              const p =  parseNumber(data.phone, {extended: true}, metadata );
              data.country = p.country;
            }

            if (this.model.id) {
              this.updateContact(this.model.id, data);
            } else {
              this.createContact(data);
            }
          }

        }else{
          this.errorMessage = this.$i18n.t('message.invalid_form_data');
        }
      },
      createContact(data) {
        this.loading = true;
        this.$store.dispatch('createContact', data).then(d => {
          this.loading = false;
          this.visible = false;
          this.$bus.$emit('contactCreated', data);
        }).catch(err => {
          this.loading = false;
          this.errorMessage = this.$i18n.t('message.error_creating_contact');
          console.log(err);
        });
      },
      updateContact(id, data) {
        this.loading = true;
        this.$store.dispatch('updateContact', {
          id:  id,
          data: data,
        }).then(d => {
          this.loading = false;
          this.$bus.$emit('contactUpdated', data);
          this.visible = false;
        }).catch(err => {
          this.loading = false;
          this.errorMessage = this.$i18n.t('message.error_updating_contact');
          console.log(err);
        });
      }
    },
    created() {
      this.$validator.reset();
      const data = this.data;
      let phone = data.phone || '';
      let country = data.country || '';
      if(phone){
        try{
          const p = data.country?
            parseNumber(data.phone, data.country, {extended: true}, metadata ):
            parseNumber(data.phone, {extended: true}, metadata );
          phone = p.phone;
          country = country || p.country;
        }catch(err){
          console.log(err)
        }
      }

      this.model = {
        id: this.data.id || null,
        first_name: this.data.first_name || null,
        last_name: this.data.last_name || null,
        email: this.data.email || null,
        localPhone: phone,
        country: country
      };
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/common/ContactModal.vue